module.exports = __webpack_public_path__ + "static/media/codeSara.70311ea7.png";